module.exports = __webpack_public_path__ + "img/主营业务_软件产品中心09.d6c4f7c4.png";